import React, { useState, useEffect, useRef } from 'react';
import {
  generateClaimForm,
  downloadPdf,
  debugPdfFields,
  generateDebugPdf
} from './pdfGenerator.js';
import {
  ClaimShipment,
  GetProofOfDelivery,
  GetShipmentDetails,
  UploadFile,
  UploadFileAPI
} from '../../apis/Agency.js';
import {
  Grid,
  Typography,
  Box,
  IconButton,
  Button,
  Chip,
  Card,
  CardContent,
  Paper,
  CardHeader
} from '@mui/material';
import { ErrorToast, successToast } from '../../components/Toasts.js';
import { ToastContainer } from 'react-toastify';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import {
  PictureAsPdf,
  Description,
  TableChart,
  InsertDriveFile,
  CheckCircle,
  LocalShipping,
  Assignment,
  Image as ImageIcon,
  Visibility,
  AirportShuttle
} from '@mui/icons-material';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stepper,
  Step,
  StepLabel,
  TextField,
  Checkbox,
  FormControlLabel,
  Divider,
  CircularProgress,
  Stack,
  DialogContentText,
  MenuItem
} from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

import { Close } from '@mui/icons-material';
import ClaimDialog from '../ClaimShipments.js';
import { useSelector } from 'react-redux';
import { base_logo_url } from '../../apis/constants.js';
import PackagingSlip from '../ViewShipment/PackagingSlip.js';
import { useIsMobile } from '../../components/IsMobileHook/IsMobileHook.js';
import html2pdf from 'html2pdf.js';
import BillOfLading from '../ViewShipment/BillOfLading.js';

const steps = ['Claim Form', 'Attachments', 'Preview'];

const SaiaClaimFormStepper = ({ shipmentDetails, open, onClose }) => {
  const contentRef = useRef(null);
  const isMobile = useIsMobile();
  const AgencyID = useSelector(state => state.userDetails.agencyLoginID);
  const [activeStep, setActiveStep] = useState(0);
  const [openPrintPDfDialogData, setOpenPrintPDfDialogData] = useState(false);
  const [packagingSlipAttached, setPackagingSlipAttached] = useState(false);
  const [BOLAttached, setBOLAttached] = useState(false);
  const [status, setStatus] = useState('Submitted');

  const claimStatuses = [
    'Submitted',
    'Under Review',
    'Awaiting Response',
    'Accepted',
    'Rejected',
    'Paid',
    'Unpaid'
  ];
  const [formData, setFormData] = useState({
    carriersFreightBillNo: '',
    shippersName: shipmentDetails?.originCompany,
    nameOfCarrierIssuingBill: 'SAIA LTL Freight',
    dateOfBillOfLading: shipmentDetails?.createdOn,
    pointShippedFrom:
      shipmentDetails?.originCity +
      ' ' +
      shipmentDetails?.originState +
      ' ' +
      shipmentDetails?.originZipCode +
      ' ' +
      shipmentDetails?.originCountry,
    deliveringCarriersFreightBillNo: '',
    consigneesName: shipmentDetails?.destinationCompany,
    nameOfDeliveringCarrier: 'SAIA LTL Freight',
    dateOfDelivery: shipmentDetails?.actualDeliveryDate,
    finalDestination:
      shipmentDetails?.destinationCity +
      ' ' +
      shipmentDetails?.destinationState +
      ' ' +
      shipmentDetails?.destinationZipCode +
      ' ' +
      shipmentDetails?.destinationCountry,
    reconsignmentParticulars: '',
    warehousingParticulars: '',
    claimType: 'Damage',
    salvageReason: '',
    salvageContactName: '',
    salvageContactPhone: '',
    salvageLocation: '',
    claimAmount: shipmentDetails?.shipmentCharges,
    totalWeight: shipmentDetails?.totalGrossWeight,
    totalAmount: shipmentDetails?.shipmentCharges,
    claimantCompanyName: shipmentDetails?.originCompany,
    claimantAddress: shipmentDetails?.originAddress,
    claimantCityStateZip:
      shipmentDetails?.originCity +
      ' ' +
      shipmentDetails?.originState +
      ' ' +
      shipmentDetails?.originZipCode +
      ' ' +
      shipmentDetails?.originCountry,
    claimantContactName: shipmentDetails?.originContactPerson,
    claimantEmail: shipmentDetails?.originContactEmail,
    claimantPhone: shipmentDetails?.originContactPhone
  });

  const [documents, setDocuments] = useState([]);
  const [loadingPOD, setLoadingPOD] = useState(false);
  const [claimFormData, setClaimFormData] = useState({
    claimType: '',
    claimNotes: '',
    claimStatus: 'Submitted',
    pictures: [],
    invoice: null,
    claimForm: null
  });

  const [isGenerating, setIsGenerating] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [generatedClaimFile, setGeneratedClaimFile] = useState('');
  const [items, setItems] = useState([]);
  const [shipDetailsArr, setShipDetailsArr] = useState([]);
  const [fetchItemsLoader, setFetchItemsLoader] = useState(false);
  const [files, setFiles] = useState([]);
  const [packagingSlipDialogOpen, setPackagingSlipDialogOpen] = useState(false);
  const [billOfLadingDialog, setBillOfLadingDialog] = useState(false);
  const [claimFormAttached, setClaimFormAttached] = useState(null);
  const [claimFormDialog, setClaimFormDialog] = useState(false);
  const [previewUrlSlip, setPreviewUrlSlip] = useState(null);
  const [previewUrlBOL, setPreviewUrlBOL] = useState(null);
  const [proofOfDeliveryAttached, setProofOfDeliveryAttached] = useState(null);
  const [proofOfDeliveryDialog, setProofOfDeliveryDialog] = useState(false);
  const [previewProofOfDelivery, setPreviewProofOfDelivery] = useState([]);
  const [PodDocLoader, setPodDocLoader] = useState(false);
  const [blobUrlPOD, setBlobUrlPOD] = useState('');

  const handleFetchLineItems = () => {
    setItems([]);
    setShipDetailsArr([]);
    setFetchItemsLoader(true);
    GetShipmentDetails(shipmentDetails.shipmentId)
      .then(res => {
        if (res.status === 200) {
          setItems(res.data.data);
          setShipDetailsArr(res.data.data);
          setFetchItemsLoader(false);
        }
      })
      .catch(err =>
        ErrorToast(`Get Shipment Details API failed due to ${err?.message}`)
      );
  };

  useEffect(() => {
    handleFetchLineItems();
  }, [shipmentDetails?.shipmentId]);

  const handleInputChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleItemChange = (index, e) => {
    const { name, value } = e.target;
    const updated = [...items];
    updated[index][name] = value;
    setItems(updated);
  };

  const handleRemoveItem = index => {
    setItems(items.filter((_, i) => i !== index));
  };

  const generatePreview = async () => {
    setIsGenerating(true);
    try {
      const pdfBytes = await generateClaimForm(
        formData,
        items,
        packagingSlipAttached,
        BOLAttached,
        claimFormAttached
      );
      const blob = new Blob([pdfBytes], { type: 'application/pdf' });

      // Create a File object from blob (helps keep filename & type consistent)
      const file = new File(
        [blob],
        `SAIA_Claim_Form_PRO_${shipmentDetails?.proNumber}.pdf`,
        {
          type: 'application/pdf'
        }
      );

      // Blob URL for preview
      const url = URL.createObjectURL(blob);
      if (previewUrl) URL.revokeObjectURL(previewUrl);

      setPreviewUrl(url);
      setGeneratedClaimFile(file);
    } finally {
      setIsGenerating(false);
    }
  };

  const handleDownload = async () => {
    setIsGenerating(true);
    try {
      const pdfBytes = await generateClaimForm(formData, items);
      downloadPdf(pdfBytes, `SAIA_Claim_Form_${Date.now()}.pdf`);
    } finally {
      setIsGenerating(false);
    }
  };
  const handleUpload = (field, file, files) => {
    const claimFormData = new FormData();
    claimFormData.append('file', file); // single file

    UploadFileAPI('CLAIM_DOCUMENTS', claimFormData)
      .then(res => {
        if (res.status === 200) {
          if (field === 'CLAIM_FORM') {
            setClaimFormData(prev => {
              return {
                ...prev,
                pictures: [...(prev.pictures || []), file]
              };
            });
            setClaimFormDialog(false);
          }
          setDocuments(prev => {
            if (!res?.data?.data || !file) {
              return prev;
            }

            const filePath = base_logo_url + (res.data.data || '');

            return [
              ...prev,
              {
                claimId: 0,
                name: file.name,
                fileType: file.type || '',
                filePath
              }
            ];
          });
        }
      })
      .catch(err => {
        console.error('Upload error:', err);
      });
  };

  const handleDownloadPOD = async () => {
    setLoadingPOD(true); // start loader
    try {
      for (let index = 0; index < files.length; index++) {
        const fileUrl = files[index].url;

        const response = await fetch(fileUrl, { mode: 'cors' });
        if (!response.ok) throw new Error(`Failed to fetch: ${fileUrl}`);

        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = `SAIA_Proof_of_Delivery_page_${
          index + 1
        }${getFileExtension(fileUrl)}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(blobUrl);
      }
    } catch (error) {
      console.error('Download failed', error);
    } finally {
      setLoadingPOD(false); // stop loader
    }
  };

  const getFileExtension = url => {
    const parts = url.split('.');
    return parts.length > 1 ? '.' + parts.pop().split(/\#|\?/)[0] : '';
  };

  const generatePDF = async (
    pgWidth,
    fileType,
    field = 'pictures',
    action,
    podLinks = []
  ) => {
    const element = document.getElementById('pdf-content');

    // ✅ If it's POD (proof of delivery) and we have URLs
    if (fileType === 'pod' && Array.isArray(podLinks) && podLinks.length > 0) {
      // cleanup old preview first

      if (action === 'attachSlip') {
        setProofOfDeliveryAttached(true);

        const files = [];
        // fetch all pod urls -> convert into File[]
        for (let i = 0; i < podLinks.length; i++) {
          const link = podLinks[i];
          setPreviewProofOfDelivery(prev => [...prev, podLinks[i].url || '']);
          const response = await fetch(link);
          const blob = await response.blob();
          const ext = blob.type.split('/')[1] || 'gif'; // try to keep ext
          const fileName = `SAIA_Proof_of_Delivery_PRO_${
            shipmentDetails?.proNumber
          }_PAGE_${i + 1}.${ext}`;
          const podFile = new File([blob], fileName, { type: blob.type });
          files.push(podFile);

          setDocuments(prev => {
            const filePath = podLinks[i].url || '';

            return [
              ...prev,
              {
                claimId: 0,
                name: podFile.name,
                fileType: podFile.type || '',
                filePath
              }
            ];
          });
        }

        setClaimFormData(prev => {
          const existingNames = (prev.pictures || []).map(f => f.name);
          const newFiles = files.filter(f => !existingNames.includes(f.name));

          if (newFiles.length === 0) return prev;

          // handleUpload(field, newFiles[0], newFiles); // pass all files
          return {
            ...prev,
            pictures: [...(prev.pictures || []), ...newFiles]
          };
        });

        setProofOfDeliveryDialog(false);
      }

      return; // ✅ skip normal PDF flow
    }

    // -----------------
    // Normal PDF flow
    // -----------------
    let pdfOptions;
    if (fileType !== 'bol') {
      const numberOfPrintsColmnVise = 1;
      const widthInPoints = 4 * 72;
      const heightInPoints =
        numberOfPrintsColmnVise === 1
          ? 6.1 * 72
          : numberOfPrintsColmnVise === 2
          ? 6.05 * 72
          : 6.01 * 72;

      pdfOptions = {
        html2canvas: { scale: 3, logging: true },
        jsPDF: {
          unit: 'pt',
          format: [widthInPoints, heightInPoints],
          orientation: 'portrait'
        }
      };
    } else {
      const contentHeight = element.scrollHeight;
      const heightInPoints = contentHeight - (contentHeight * 25) / 100;

      pdfOptions = {
        html2canvas: { scale: 3, logging: false },
        pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
        jsPDF: {
          unit: 'pt',
          format: [1250, heightInPoints],
          orientation: 'portrait'
        }
      };
    }

    const worker = html2pdf().from(element).set(pdfOptions);
    const pdfBlob = await worker.outputPdf('blob');
    const fileName =
      fileType === 'bol'
        ? `SAIA_BOL_PRO_${shipmentDetails?.proNumber}.pdf`
        : `SAIA_PackagingSlip_PRO_${shipmentDetails?.proNumber}.pdf`;

    const pdfFile = new File([pdfBlob], fileName, { type: 'application/pdf' });

    const previewUrl = URL.createObjectURL(pdfBlob);
    if (fileType === 'bol') {
      if (previewUrlBOL) URL.revokeObjectURL(previewUrlBOL);
      setPreviewUrlBOL(previewUrl);
    } else {
      if (previewUrlSlip) URL.revokeObjectURL(previewUrlSlip);
      setPreviewUrlSlip(previewUrl);
    }

    if (action === 'attachSlip') {
      setClaimFormData(prev => {
        const alreadyExists = (prev.pictures || []).some(
          file => file.name === pdfFile.name
        );
        if (alreadyExists) return prev;

        handleUpload(field, pdfFile, [pdfFile]);
        return { ...prev, pictures: [...(prev.pictures || []), pdfFile] };
      });
      setPackagingSlipDialogOpen(false);
      setBillOfLadingDialog(false);
    }

    if (action === 'downloadSlip') {
      if (fileType === 'pod') {
        podLinks.forEach(element => {
          const link = document.createElement('a');
          link.href = element.url;
          link.setAttribute('download', '');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        });
      }
      await worker.save(fileName);
    }
  };

  console.log(previewProofOfDelivery, 'previewProofOfDelivery');

  const handleFileChange = (field, files) => {
    Array.from(files).forEach(file => {
      setClaimFormData(prev => {
        const alreadyExists = (prev[field] || []).some(
          existingFile => existingFile.name === file.name
        );

        if (alreadyExists) {
          return prev;
        }

        // ✅ upload any allowed file type (images, pdf, doc, xls, csv, etc.)
        handleUpload(field, file, files);

        return {
          ...prev,
          [field]: [...(prev[field] || []), file]
        };
      });
    });
  };

  const handleRemoveFile = idx => {
    const fileToRemove = claimFormData.pictures[idx];

    setClaimFormData(prev => ({
      ...prev,
      pictures: prev.pictures.filter((_, i) => i !== idx)
    }));

    setDocuments(prev => prev.filter(doc => doc.name !== fileToRemove.name));
  };

  console.log(documents, claimFormData, 'documents');

  const handleNext = async () => {
    // if (activeStep === steps.length - 2) {
    //   await generatePreview();
    // }
    setActiveStep(prev => Math.min(prev + 1, steps.length - 1));
  };

  const handleBack = () => {
    setActiveStep(prev => Math.max(prev - 1, 0));
  };

  const handleReset = () => {
    setActiveStep(0);
    setFiles([]);
    setPreviewUrl(null);
  };

  const handleCloseClaimFun = type => {
    onClose('success');
    setClaimFormDialog(false);
    setDocuments([
      {
        claimId: 0,
        name: '',
        fileType: '',
        filePath: ''
      }
    ]);
    setClaimFormData({
      claimType: '',
      claimNotes: '',
      claimStatus: 'Submitted',
      pictures: [],
      invoice: null,
      claimForm: null
    });
  };
  const skidCountInfo = items
    .map(
      item =>
        `${item.units} ${item.packagingType}${item.units > 1 ? 's' : ''} (${
          item.pieces
        } Pieces)`
    )
    .join(', ');

  const handleSubmit = () => {
    const totalGrossWeight = (items || []).reduce(
      (sum, item) => sum + (parseFloat(item.grossWeight) || 0),
      0
    );

    const totalClaimAmount = (items || []).reduce(
      (sum, item) => sum + (parseFloat(item.itemTotalAmount) || 0),
      0
    );
    const totalUnits = items.reduce((sum, item) => {
      const units = Number(item.units) || 0; // convert to number, fallback 0
      return sum + units;
    }, 0);
    const claimObj = {
      id: 0,
      agencyId: AgencyID,
      shipmentId: shipmentDetails?.shipmentId ?? 0,
      claimStatus: status ?? '',
      claimType: formData?.claimType ?? '',
      claimNumber: formData?.carriersFreightBillNo ?? '',
      filedDate: new Date(),
      affectedClaimWeight: totalGrossWeight ?? 0,
      affectedClaimQuantity: totalUnits,
      affectedPONumber: '',
      affectedCommodities: skidCountInfo,
      claimAmount: formData?.claimAmount ?? '',
      salvageReturned: '',
      concealedDamageLoss: '',
      additionalComments: formData?.salvageReason ?? '',
      claimAmountReceived: 0,
      carrierCheckNumber: '',
      paymentReceivingDate: new Date(),
      documents: documents
    };

    ClaimShipment(claimObj)
      .then(res => {
        res.status === 200 && successToast('Shipment claimed successfully!');
        handleCloseClaimFun('success');
      })
      .catch(err => {
        ErrorToast(err?.message);
        handleCloseClaimFun();
      });
  };
  useEffect(() => {
    const hasPackagingSlip =
      claimFormData &&
      claimFormData?.pictures?.some(file =>
        file?.name?.includes('PackagingSlip')
      );
    const BOLAttached =
      claimFormData &&
      claimFormData?.pictures?.some(file => file?.name?.includes('BOL'));
    setPackagingSlipAttached(hasPackagingSlip);
    const ClaimFormAttached =
      claimFormData &&
      claimFormData?.pictures?.some(file => file?.name?.includes('Claim'));
    setClaimFormAttached(ClaimFormAttached);

    setBOLAttached(BOLAttached);
  }, [claimFormData]);

  const MAX_LIMITS = {
    reconsignmentParticulars: 120,
    warehousingParticulars: 20,
    salvageLocation: 35,
    salvageReason: 220
  };

  const getFileTypeInfo = file => {
    const extension = file.name.split('.').pop().toLowerCase();
    const fileType = file.type.toLowerCase();

    if (fileType.startsWith('image/')) {
      return {
        icon: <ImageIcon sx={{ fontSize: 40 }} />,
        color: '#4caf50',
        label: 'Image'
      };
    } else if (extension === 'pdf' || fileType === 'application/pdf') {
      return {
        icon: <PictureAsPdf sx={{ fontSize: 40 }} />,
        color: '#f44336',
        label: 'PDF'
      };
    } else if (
      ['doc', 'docx'].includes(extension) ||
      fileType.includes('word')
    ) {
      return {
        icon: <Description sx={{ fontSize: 40 }} />,
        color: '#2196f3',
        label: 'Document'
      };
    } else if (
      ['xls', 'xlsx', 'csv'].includes(extension) ||
      fileType.includes('sheet')
    ) {
      return {
        icon: <TableChart sx={{ fontSize: 40 }} />,
        color: '#4caf50',
        label: 'Spreadsheet'
      };
    } else {
      return {
        icon: <InsertDriveFile sx={{ fontSize: 40 }} />,
        color: '#757575',
        label: 'File'
      };
    }
  };

  // Helper function to format file size
  const formatFileSize = bytes => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };
  const PDFPreviewCard = ({ title, previewUrl, icon, color, description }) => (
    <Card
      sx={{
        mb: 3,
        border:
          title === 'Proof of Delivery'
            ? previewUrl && previewUrl.length > 0
              ? `2px solid ${color}`
              : '1px solid #e0e0e0'
            : previewUrl
            ? `2px solid ${color}`
            : '1px solid #e0e0e0'
      }}
    >
      <CardHeader
        avatar={
          <Box sx={{ color: color, display: 'flex', alignItems: 'center' }}>
            {icon}
          </Box>
        }
        title={
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant='h6'>{title}</Typography>
            {title === 'Proof of Delivery'
              ? previewUrl && previewUrl.length > 0
              : previewUrl && (
                  <Chip
                    label='Generated'
                    size='small'
                    sx={{
                      backgroundColor: color,
                      color: 'white',
                      fontSize: '10px'
                    }}
                  />
                )}
          </Box>
        }
        subheader={description}
        sx={{ pb: 1 }}
      />
      <CardContent sx={{ pt: 0 }}>
        {(title === 'Proof of Delivery' &&
          previewUrl &&
          previewUrl.length > 0) ||
        (title !== 'Proof of Delivery' && previewUrl) ? (
          <Paper
            elevation={3}
            sx={{
              borderRadius: 2,
              overflow: 'hidden',
              border: `1px solid ${color}30`
            }}
          >
            {title === 'Proof of Delivery' ? (
              previewUrl.map((items, idx) => (
                <iframe
                  key={idx}
                  src={items}
                  title={`${title} Preview ${idx}`}
                  width='100%'
                  height='600px'
                  style={{ border: 'none', display: 'block' }}
                />
              ))
            ) : (
              <iframe
                src={previewUrl}
                title={`${title} Preview`}
                width='100%'
                height='600px'
                style={{ border: 'none', display: 'block' }}
              />
            )}
          </Paper>
        ) : (
          <Box
            sx={{
              height: 200,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: '#f8f9fa',
              borderRadius: 2,
              border: '2px dashed #dee2e6'
            }}
          >
            <Box sx={{ color: '#6c757d', mb: 2 }}>{icon}</Box>
            <Typography color='text.secondary' variant='body2'>
              {description || `Generate ${title} to see preview`}
            </Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );
  const getDocumentTypeInfo = fileName => {
    if (fileName.includes('Slip')) {
      return {
        icon: <LocalShipping sx={{ fontSize: 40 }} />,
        color: '#2196f3',
        label: 'Packaging Slip',
        bgColor: '#e3f2fd'
      };
    } else if (fileName.includes('BOL')) {
      return {
        icon: <Description sx={{ fontSize: 40 }} />,
        color: '#ff9800',
        label: 'Bill of Lading',
        bgColor: '#fff3e0'
      };
    } else if (fileName.includes('Claim')) {
      return {
        icon: <Assignment sx={{ fontSize: 40 }} />,
        color: '#4caf50',
        label: 'Claim Form',
        bgColor: '#e8f5e8'
      };
    } else if (fileName.includes('Proof')) {
      return {
        icon: <AirportShuttle sx={{ fontSize: 40 }} />,
        color: '#9baf51',
        label: 'POD',
        bgColor: '#f8f5e8'
      };
    } else {
      return {
        icon: <PictureAsPdf sx={{ fontSize: 40 }} />,
        color: '#f44336',
        label: 'PDF Document',
        bgColor: '#ffebee'
      };
    }
  };
  const viewPOD = (fileType, base64Data, urls, fileName) => {
    let mimeType;
    if (base64Data !== null) {
      switch (fileType.toLowerCase()) {
        case 'pdf':
        case '.pdf':
          mimeType = 'application/pdf';
          break;
        case 'tif':
        case 'tiff':
        case 'tifv':
          mimeType = 'image/tiff';
          break;
        case '.gif':
        case 'gif':
          mimeType = 'image/gif';
          break;
        case 'jpg':
        case '.jpg':
          mimeType = 'image/jpg';
          break;
        default:
          ErrorToast('Unsupported file type');
          return;
      }

      const linkSource = `data:${mimeType};base64,${base64Data}`;
      const downloadLink = document.createElement('a');
      downloadLink.href = linkSource;

      // Set the download attribute with the correct file extension
      downloadLink.download = fileName.endsWith(`.${fileType}`)
        ? fileName
        : `${fileName}.${fileType}`;

      // Trigger the download
      downloadLink.click();
    }
    if (urls && Array.isArray(urls)) {
      setFiles(prevFiles => [
        ...prevFiles,
        ...urls.filter(Boolean).map(url => ({ url }))
      ]);
    }
  };
  const handleProofOfDeliveryRequest = status => {
    setPodDocLoader(true);
    const obj = {
      carrier: {
        id: shipmentDetails?.carrierId ? shipmentDetails.carrierId : 0,
        name: shipmentDetails?.carrierName
          ? shipmentDetails.carrierName
          : 'string',
        logo: 'string'
      },
      proNumber: shipmentDetails?.proNumber.trim(),
      shipmentId: shipmentDetails?.shipmentId,
      locationId: shipmentDetails?.locationId,
      agencyId: AgencyID ? AgencyID : 0
    };
    GetProofOfDelivery(obj)
      .then(res => {
        res.status === 200 && setPodDocLoader(false);
        viewPOD(
          res.data.fileExtension,
          res.data.fileBase64,
          res.data.urLs,
          `Proof of Delivery (${obj.carrier.name}  ${obj.proNumber})`
        );
      })
      .catch(err => {
        setPodDocLoader(false);
        setBlobUrlPOD(null);
        ErrorToast(JSON.stringify(err?.response?.data));
      });
  };

  // Document Generation Card Component
  const DocumentGenerationCard = ({
    title,
    buttonText,
    isAttached,
    onGenerate,
    files,
    onRemoveFile,
    icon,
    color
  }) => (
    <Card
      sx={{
        height: '100%',
        border: isAttached ? `2px solid ${color}` : '1px solid #e0e0e0',
        boxShadow: isAttached ? 3 : 1,
        transition: 'all 0.3s ease'
      }}
    >
      <CardContent sx={{ p: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <Box sx={{ color: color, mr: 1 }}>{icon}</Box>
          <Typography variant='subtitle2' sx={{ flexGrow: 1 }}>
            {title}
          </Typography>
          {isAttached && <CheckCircle sx={{ color: color, fontSize: 20 }} />}
        </Box>

        {title === 'Proof of Delivery' && PodDocLoader ? (
          <CircularProgress size={20} />
        ) : (
          <Button
            disabled={isAttached}
            size='small'
            variant={isAttached ? 'contained' : 'outlined'}
            onClick={onGenerate}
            fullWidth
            sx={{
              mb: 2,
              backgroundColor: isAttached ? color : 'transparent',
              borderColor: color,
              color: isAttached ? 'white' : color,
              '&:hover': {
                backgroundColor: isAttached ? color : `${color}10`,
                borderColor: color
              }
            }}
          >
            {isAttached ? 'Generated' : buttonText}
            {isAttached && <CheckCircle sx={{ fontSize: 16, ml: 1 }} />}
          </Button>
        )}

        {/* Display attached files */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {files?.map((file, idx) => {
            const docInfo = getDocumentTypeInfo(file.name);
            return (
              <Box
                key={idx}
                sx={{
                  position: 'relative',
                  display: 'flex',
                  alignItems: 'center',
                  p: 1,
                  border: '1px solid #e0e0e0',
                  borderRadius: 1,
                  backgroundColor: docInfo.bgColor,
                  minHeight: 60
                }}
              >
                <Box
                  sx={{
                    color: docInfo.color,
                    mr: 2,
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  {docInfo.icon}
                </Box>

                <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                  <Typography
                    variant='body2'
                    sx={{
                      fontWeight: 500,
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      mb: 0.5
                    }}
                  >
                    {file.name}
                  </Typography>

                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Chip
                      label={docInfo.label}
                      size='small'
                      sx={{
                        backgroundColor: docInfo.color,
                        color: 'white',
                        fontSize: '10px',
                        height: 20
                      }}
                    />
                    <Typography
                      variant='caption'
                      sx={{
                        color: 'text.secondary',
                        fontSize: '10px'
                      }}
                    >
                      {file.size ? formatFileSize(file.size) : 'PDF'}
                    </Typography>
                  </Box>
                </Box>

                {/* Remove button */}
                <IconButton
                  size='small'
                  sx={{
                    width: 24,
                    height: 24,
                    backgroundColor: '#f44336',
                    color: 'white',
                    ml: 1,
                    '&:hover': {
                      backgroundColor: '#d32f2f'
                    }
                  }}
                  onClick={() => onRemoveFile(idx)}
                >
                  ✕
                </IconButton>
              </Box>
            );
          })}
        </Box>
      </CardContent>
    </Card>
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth='lg'
      PaperProps={{
        sx: {
          minHeight: '85vh'
        }
      }}
    >
      <ToastContainer position='top-center' autoClose={3000} />
      <DialogTitle>
        <Grid sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography>SAIA Claim Shipment</Typography>
          <Close sx={{ cursor: 'pointer' }} onClick={onClose} />
        </Grid>
        <Stepper sx={{ mt: 0 }} activeStep={activeStep} alternativeLabel>
          {steps.map(label => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
      </DialogTitle>

      <DialogContent dividers sx={{ maxHeight: '70vh' }}>
        {activeStep === 0 && (
          <div className='claimform'>
            {/* Shipment Info */}
            <Typography>Shipment Information</Typography>
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid item xs={12} md={3}>
                <TextField
                  size='small'
                  fullWidth
                  label="Carrier's Freight Bill No."
                  name='carriersFreightBillNo'
                  value={formData.carriersFreightBillNo}
                  onChange={handleInputChange}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  size='small'
                  fullWidth
                  label="Shipper's Name"
                  name='shippersName'
                  value={formData.shippersName}
                  onChange={handleInputChange}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  size='small'
                  fullWidth
                  label="Consignee's Name"
                  name='consigneesName'
                  value={formData.consigneesName}
                  onChange={handleInputChange}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  size='small'
                  fullWidth
                  label='Date of Delivery'
                  name='dateOfDelivery'
                  value={formData.dateOfDelivery}
                  // type='date'
                  onChange={handleInputChange}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>

            <Divider sx={{ mt: 2, py: 0.2 }} />

            {/* Claim Type */}
            <Typography sx={{ mt: 1 }}>Claim Type</Typography>
            <Grid container spacing={2}>
              {['Damage', 'Short', 'Concealed'].map(type => (
                <Grid item key={type} xs={12} md={2}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={formData.claimType === type}
                        onChange={() =>
                          setFormData(prev => ({ ...prev, claimType: type }))
                        }
                      />
                    }
                    label={type}
                  />
                </Grid>
              ))}
              <Grid item xs={12} md={3}>
                <TextField
                  select
                  fullWidth
                  size='small'
                  label='Claim Status'
                  value={status}
                  onChange={e => setStatus(e.target.value)}
                >
                  {claimStatuses.map((option, index) => (
                    <MenuItem key={index} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            </Grid>

            <Divider sx={{ mt: 2, py: 0.2 }} />

            {/* Salvage Info */}
            <Typography sx={{ mt: 1 }}>Salvage Information</Typography>
            <Grid container spacing={2} mt={1}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  size='small'
                  label='If shipment reconsigned en route, state particulars:'
                  name='reconsignmentParticulars'
                  value={formData.reconsignmentParticulars}
                  onChange={handleInputChange}
                  inputProps={{
                    maxLength: MAX_LIMITS.reconsignmentParticulars
                  }}
                  helperText={
                    formData.reconsignmentParticulars?.length >=
                    MAX_LIMITS.reconsignmentParticulars
                      ? `Max ${MAX_LIMITS.reconsignmentParticulars} characters allowed`
                      : `${formData.reconsignmentParticulars?.length || 0}/${
                          MAX_LIMITS.reconsignmentParticulars
                        }`
                  }
                  error={
                    formData.reconsignmentParticulars?.length >=
                    MAX_LIMITS.reconsignmentParticulars
                  }
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  size='small'
                  label='If shipment moved from warehousing/distribution point, indicate particulars:'
                  name='warehousingParticulars'
                  value={formData.warehousingParticulars}
                  onChange={handleInputChange}
                  inputProps={{ maxLength: MAX_LIMITS.warehousingParticulars }}
                  helperText={
                    formData.warehousingParticulars?.length >=
                    MAX_LIMITS.warehousingParticulars
                      ? `Max ${MAX_LIMITS.warehousingParticulars} characters allowed`
                      : `${formData.warehousingParticulars?.length || 0}/${
                          MAX_LIMITS.warehousingParticulars
                        }`
                  }
                  error={
                    formData.warehousingParticulars?.length >=
                    MAX_LIMITS.warehousingParticulars
                  }
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  size='small'
                  label='Location of damaged merchandise:'
                  name='salvageLocation'
                  value={formData.salvageLocation}
                  onChange={handleInputChange}
                  inputProps={{ maxLength: MAX_LIMITS.salvageLocation }}
                  helperText={
                    formData.salvageLocation?.length >=
                    MAX_LIMITS.salvageLocation
                      ? `Max ${MAX_LIMITS.salvageLocation} characters allowed`
                      : `${formData.salvageLocation?.length || 0}/${
                          MAX_LIMITS.salvageLocation
                        }`
                  }
                  error={
                    formData.salvageLocation?.length >=
                    MAX_LIMITS.salvageLocation
                  }
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  label='Reason cannot mitigate...'
                  name='salvageReason'
                  value={formData.salvageReason}
                  onChange={handleInputChange}
                  inputProps={{ maxLength: MAX_LIMITS.salvageReason }}
                  InputLabelProps={{ shrink: true }}
                  helperText={
                    formData.salvageReason?.length >= MAX_LIMITS.salvageReason
                      ? `Max ${MAX_LIMITS.salvageReason} characters allowed`
                      : `${formData.salvageReason?.length || 0}/${
                          MAX_LIMITS.salvageReason
                        }`
                  }
                  error={
                    formData.salvageReason?.length >= MAX_LIMITS.salvageReason
                  }
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  size='small'
                  label='Salvage/ inspection contact name'
                  name='salvageContactName'
                  value={formData.salvageContactName}
                  onChange={handleInputChange}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  size='small'
                  label='Salvage/ inspection contact phone'
                  name='salvageContactPhone'
                  value={formData.salvageContactPhone}
                  onChange={e => {
                    let input = e.target.value.replace(/\D/g, '');
                    if (input.length > 10) input = input.slice(0, 10);

                    let formatted = input;
                    if (input.length > 3 && input.length <= 6) {
                      formatted = `${input.slice(0, 3)} ${input.slice(3)}`;
                    } else if (input.length > 6) {
                      formatted = `${input.slice(0, 3)} ${input.slice(
                        3,
                        6
                      )}-${input.slice(6)}`;
                    }

                    handleInputChange({
                      target: { name: 'salvageContactPhone', value: formatted }
                    });
                  }}
                />
              </Grid>
            </Grid>

            <Divider sx={{ mt: 2, py: 0.2 }} />

            {/* Item Details */}
            <Typography sx={{ my: 0.4 }}>Item Details</Typography>
            {items.map((item, index) => (
              <Grid container spacing={2} key={index} alignItems='center'>
                <Grid item xs={12} md={2}>
                  <TextField
                    size='small'
                    fullWidth
                    label='Quantity'
                    name='units'
                    value={item.units}
                    onChange={e => handleItemChange(index, e)}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    size='small'
                    fullWidth
                    label='Description'
                    name='itemDescription'
                    value={item.itemDescription}
                    onChange={e => handleItemChange(index, e)}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <TextField
                    size='small'
                    fullWidth
                    label='Unit Price'
                    name='itemUnitPrice'
                    value={item.itemUnitPrice}
                    onChange={e => handleItemChange(index, e)}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <TextField
                    size='small'
                    fullWidth
                    label='Total Amount'
                    name='itemTotalAmount'
                    value={item.itemTotalAmount}
                    onChange={e => handleItemChange(index, e)}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <TextField
                    size='small'
                    fullWidth
                    label='Gross Weight'
                    name='grossWeight'
                    value={item.grossWeight}
                    onChange={e => handleItemChange(index, e)}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sx={{ display: 'flex', justifyContent: 'end' }}
                >
                  <Button
                    sx={{ mb: 0.8 }}
                    variant='contained'
                    size='small'
                    color='error'
                    onClick={() => handleRemoveItem(index)}
                  >
                    Remove
                  </Button>
                </Grid>
              </Grid>
            ))}

            <Button
              disabled={fetchItemsLoader}
              variant='contained'
              size='small'
              sx={{
                minWidth: 150,
                mt: fetchItemsLoader ? 0 : -4.2,
                color: 'white',
                textAlign: 'center'
              }}
              onClick={handleFetchLineItems}
            >
              Fetch Items{' '}
              {fetchItemsLoader && (
                <CircularProgress sx={{ ml: 1 }} size={18} />
              )}
            </Button>

            <Divider sx={{ mt: 2, py: 0.2 }} />

            {/* Claim Details */}
            <Typography sx={{ mt: 3 }}>Claim Details</Typography>
            <TextField
              sx={{ mt: 1 }}
              fullWidth
              label='Claim Amount'
              name='claimAmount'
              type='number'
              value={formData.claimAmount}
              onChange={handleInputChange}
              InputLabelProps={{ shrink: true }}
            />

            <Divider sx={{ mt: 2, py: 0.2 }} />

            {/* Claimant Info */}
            <Typography sx={{ mt: 1 }}>Claimant Information</Typography>
            <Grid container spacing={2} sx={{ mt: 0 }}>
              <Grid item xs={12} md={3}>
                <TextField
                  size='small'
                  fullWidth
                  label='Company Name'
                  name='claimantCompanyName'
                  value={formData.claimantCompanyName}
                  onChange={handleInputChange}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  size='small'
                  fullWidth
                  label='Contact Name'
                  name='claimantContactName'
                  value={formData.claimantContactName}
                  onChange={handleInputChange}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  size='small'
                  fullWidth
                  type='email'
                  label='Email Address'
                  name='claimantEmail'
                  value={formData.claimantEmail}
                  onChange={handleInputChange}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  size='small'
                  fullWidth
                  type='tel'
                  label='Phone Number'
                  name='claimantPhone'
                  value={formData.claimantPhone}
                  onChange={handleInputChange}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  size='small'
                  label='Address'
                  name='claimantAddress'
                  value={formData.claimantAddress}
                  onChange={handleInputChange}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  size='small'
                  label='City, State, Zip'
                  name='claimantCityStateZip'
                  value={formData.claimantCityStateZip}
                  onChange={handleInputChange}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          </div>
        )}

        {activeStep === 1 && (
          <>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant='subtitle2'>
                  Upload Claim Images / Attachements
                </Typography>
                <Box
                  sx={{
                    border: '2px dashed #ccc',
                    borderRadius: 2,
                    p: 5,
                    textAlign: 'center',
                    mt: 0,
                    cursor: 'pointer',
                    '&:hover': {
                      borderColor: 'primary.main',
                      backgroundColor: '#fafafa'
                    }
                  }}
                  onClick={() =>
                    document.getElementById('invoice-upload-input').click()
                  }
                  onDragOver={e => e.preventDefault()}
                  onDrop={e => {
                    e.preventDefault();
                    if (e.dataTransfer.files.length) {
                      handleFileChange(
                        'pictures',
                        Array.from(e.dataTransfer.files)
                      );
                    }
                  }}
                >
                  <Typography variant='body2' color='textSecondary'>
                    Drag & drop here, or click to Upload
                  </Typography>
                  <Typography
                    variant='caption'
                    color='textSecondary'
                    sx={{ mt: 1, display: 'block' }}
                  >
                    Supported formats: PDF, DOC, DOCX, XLS, XLSX, CSV, Images
                  </Typography>
                  <input
                    id='invoice-upload-input'
                    type='file'
                    hidden
                    multiple
                    accept='.pdf,.doc,.docx,.xls,.xlsx,.csv,image/*'
                    onChange={e =>
                      handleFileChange('pictures', Array.from(e.target.files))
                    }
                  />
                </Box>

                <Box sx={{ display: 'flex', gap: 2, mt: 2, flexWrap: 'wrap' }}>
                  {claimFormData.pictures?.map(
                    (file, idx) =>
                      !file.name.includes('Slip') &&
                      !file.name.includes('BOL') &&
                      !file.name.includes('Claim') &&
                      !file.name.includes('Proof') && (
                        <Box
                          key={idx}
                          sx={{
                            position: 'relative',
                            display: 'inline-block',
                            minWidth: 150,
                            maxWidth: 150
                          }}
                        >
                          <Box
                            sx={{
                              width: 150,
                              height: 120,
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              justifyContent: 'center',
                              border: '1px solid #e0e0e0',
                              borderRadius: 2,
                              backgroundColor: '#fafafa',
                              overflow: 'hidden',
                              position: 'relative'
                            }}
                          >
                            {file.type.startsWith('image/') ? (
                              // Display actual image for image files
                              <img
                                src={URL.createObjectURL(file)}
                                alt='preview'
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  objectFit: 'cover',
                                  borderRadius: 8
                                }}
                              />
                            ) : (
                              // Display icon and info for non-image files
                              <>
                                <Box
                                  sx={{
                                    color: getFileTypeInfo(file).color,
                                    mb: 1
                                  }}
                                >
                                  {getFileTypeInfo(file).icon}
                                </Box>
                                <Chip
                                  label={getFileTypeInfo(file).label}
                                  size='small'
                                  sx={{
                                    mb: 1,
                                    backgroundColor:
                                      getFileTypeInfo(file).color,
                                    color: 'white',
                                    fontSize: '10px'
                                  }}
                                />
                              </>
                            )}
                          </Box>

                          {/* File info overlay for non-images */}
                          {!file.type.startsWith('image/') && (
                            <Box
                              sx={{
                                position: 'absolute',
                                bottom: 0,
                                left: 0,
                                right: 0,
                                backgroundColor: 'rgba(0,0,0,0.8)',
                                color: 'white',
                                p: 0.5,
                                borderRadius: '0 0 8px 8px'
                              }}
                            >
                              <Typography
                                variant='caption'
                                sx={{
                                  fontSize: '10px',
                                  display: 'block',
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis'
                                }}
                              >
                                {file.name}
                              </Typography>
                              <Typography
                                variant='caption'
                                sx={{ fontSize: '9px', opacity: 0.8 }}
                              >
                                {formatFileSize(file.size)}
                              </Typography>
                            </Box>
                          )}

                          {/* File info overlay for images */}
                          {file.type.startsWith('image/') && (
                            <Box
                              sx={{
                                position: 'absolute',
                                bottom: 0,
                                left: 0,
                                right: 0,
                                backgroundColor: 'rgba(0,0,0,0.6)',
                                color: 'white',
                                p: 0.5,
                                borderRadius: '0 0 8px 8px'
                              }}
                            >
                              <Typography
                                variant='caption'
                                sx={{
                                  fontSize: '10px',
                                  display: 'block',
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis'
                                }}
                              >
                                {file.name}
                              </Typography>
                              <Typography
                                variant='caption'
                                sx={{ fontSize: '9px', opacity: 0.8 }}
                              >
                                {formatFileSize(file.size)}
                              </Typography>
                            </Box>
                          )}

                          {/* Remove button */}
                          <IconButton
                            size='small'
                            sx={{
                              position: 'absolute',
                              fontSize: 14,
                              width: 24,
                              height: 24,
                              top: -8,
                              right: -8,
                              backgroundColor: '#f44336',
                              color: 'white',
                              boxShadow: 2,
                              '&:hover': {
                                backgroundColor: '#d32f2f'
                              }
                            }}
                            onClick={() => handleRemoveFile(idx)}
                          >
                            ✕
                          </IconButton>
                        </Box>
                      )
                  )}
                </Box>
              </Grid>
            </Grid>
            <Dialog
              fullWidth
              maxWidth='xs'
              minWidth='xs'
              open={packagingSlipDialogOpen}
              onClose={() => setPackagingSlipDialogOpen(false)}
            >
              <DialogTitle sx={{ m: 0, p: 2 }}>
                Packaging Slip PRO# {shipmentDetails?.proNumber}
                <IconButton
                  aria-label='close'
                  onClick={() => setPackagingSlipDialogOpen(false)}
                  sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: theme => theme.palette.grey[500]
                  }}
                >
                  <Close />
                </IconButton>
              </DialogTitle>

              <DialogContent
                dividers
                sx={{ display: 'flex', justifyContent: 'center' }}
              >
                {/* Reusable Packaging Slip Component */}
                <PackagingSlip
                  contentRef={contentRef}
                  rowData={shipmentDetails}
                  isMobile={isMobile}
                  numberOfPrints={1}
                  openPrintPDfDialogData={{
                    ...shipmentDetails,
                    details: shipDetailsArr
                  }}
                  numberOfPrintsColmnVise={1}
                />
              </DialogContent>

              <DialogActions>
                <Button
                  variant='contained'
                  size='small'
                  onClick={() =>
                    generatePDF('', 'packagingSlip', 'pictures', 'attachSlip')
                  }
                  color='primary'
                >
                  Attach PDF
                </Button>
                <Button
                  variant='outlined'
                  size='small'
                  onClick={() =>
                    generatePDF('', 'packagingSlip', 'pictures', 'downloadSlip')
                  }
                  color='primary'
                >
                  Download PDF
                </Button>
              </DialogActions>
            </Dialog>
            <Dialog
              fullWidth
              maxWidth='lg'
              minWidth='md'
              open={billOfLadingDialog}
              onClose={() => setBillOfLadingDialog(false)}
            >
              <DialogTitle sx={{ m: 0, p: 2 }}>
                Bill of Lading PRO# {shipmentDetails?.proNumber}
                <IconButton
                  aria-label='close'
                  onClick={() => setBillOfLadingDialog(false)}
                  sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: theme => theme.palette.grey[500]
                  }}
                >
                  <Close />
                </IconButton>
              </DialogTitle>
              <DialogContent dividers>
                <DialogContentText
                  sx={{ m: -3 }}
                  ref={contentRef}
                  id='alert-dialog-description'
                >
                  <div
                    id='pdf-content'
                    style={{
                      minWidth: '100%',
                      minHeight: '100%'
                    }}
                  >
                    <BillOfLading
                      rowData={shipDetailsArr}
                      rowData2={shipmentDetails}
                    />
                  </div>
                </DialogContentText>
              </DialogContent>

              <DialogActions>
                <Button
                  disabled={BOLAttached}
                  variant='contained'
                  size='small'
                  onClick={() =>
                    generatePDF('', 'bol', 'pictures', 'attachSlip')
                  }
                  color='primary'
                >
                  Attach PDF{' '}
                  {BOLAttached && <CheckCircleIcon sx={{ fontSize: 15 }} />}
                </Button>
                <Button
                  variant='outlined'
                  size='small'
                  onClick={() =>
                    generatePDF('', 'bol', 'pictures', 'downloadSlip')
                  }
                  color='primary'
                >
                  Download PDF
                </Button>
              </DialogActions>
            </Dialog>

            <Dialog
              fullWidth
              maxWidth='lg'
              minWidth='lg'
              PaperProps={{ sx: { minHeight: '50%', overflow: 'hidden' } }}
              open={proofOfDeliveryDialog}
              onClose={() => {
                setFiles([]);
                setProofOfDeliveryDialog(false);
              }}
            >
              <DialogTitle sx={{ m: 0, p: 2 }}>
                Proof of Delivery PRO# {shipmentDetails?.proNumber}
                <IconButton
                  aria-label='close'
                  onClick={() => {
                    setFiles([]);
                    setProofOfDeliveryDialog(false);
                  }}
                  sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: theme => theme.palette.grey[500]
                  }}
                >
                  <Close />
                </IconButton>
              </DialogTitle>
              <DialogContent dividers>
                <DialogContentText
                  sx={{ p: 1 }}
                  ref={contentRef}
                  id='alert-dialog-description'
                >
                  <Box
                    sx={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      justifyContent: 'center',
                      alignItems: 'center',
                      gap: 2
                    }}
                  >
                    {PodDocLoader ? (
                      <CircularProgress sx={{ mt: '10%' }} size={30} />
                    ) : (
                      files.map((file, index) => {
                        const url = typeof file === 'string' ? file : file.url; // handle string or object
                        const isImage = url.match(
                          /\.(jpeg|jpg|png|gif|webp)$/i
                        );

                        return isImage ? (
                          <img
                            key={index}
                            src={url}
                            alt={`preview-${index}`}
                            width='400px'
                            style={{
                              border: '1px solid #ccc',
                              borderRadius: 8
                            }}
                          />
                        ) : (
                          <iframe
                            key={index}
                            src={url}
                            title={`preview-${index}`}
                            width='400px'
                            height='400px'
                            style={{
                              border: '1px solid #ccc',
                              borderRadius: 8
                            }}
                          />
                        );
                      })
                    )}
                  </Box>
                </DialogContentText>
              </DialogContent>

              <DialogActions>
                <Button
                  disabled={proofOfDeliveryAttached}
                  variant='contained'
                  size='small'
                  onClick={() =>
                    generatePDF('', 'pod', 'pictures', 'attachSlip', files)
                  }
                  color='primary'
                >
                  Attach POD{' '}
                  {proofOfDeliveryAttached && (
                    <CheckCircleIcon sx={{ fontSize: 15 }} />
                  )}
                </Button>
                <Button
                  disabled={loadingPOD}
                  variant='outlined'
                  size='small'
                  onClick={handleDownloadPOD}
                  color='primary'
                >
                  Download POD {loadingPOD && <CircularProgress size={20} />}
                </Button>
              </DialogActions>
            </Dialog>
            <Dialog
              fullWidth
              maxWidth='md'
              minWidth='sm'
              open={claimFormDialog}
              onClose={() => setClaimFormDialog(false)}
              PaperProps={{
                sx: { overflow: 'hidden', height: '85vh' }
              }}
            >
              <DialogTitle sx={{ m: 0, p: 2 }}>
                Claim Form PRO# {shipmentDetails?.proNumber}
                <IconButton
                  aria-label='close'
                  onClick={() => setClaimFormDialog(false)}
                  sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: theme => theme.palette.grey[500]
                  }}
                >
                  <Close />
                </IconButton>
              </DialogTitle>
              <DialogContent dividers>
                <DialogContentText
                  sx={{ m: -3, overflow: 'hidden' }}
                  ref={contentRef}
                  id='alert-dialog-description'
                >
                  {previewUrl ? (
                    <iframe
                      src={previewUrl}
                      width='100%'
                      height='600px'
                      title='SAIA Claim Form Preview'
                      style={{ border: '1px solid #ccc', borderRadius: 4 }}
                    />
                  ) : (
                    <Typography color='text.secondary'>
                      Click "Preview Claim Form" to generate preview
                    </Typography>
                  )}
                </DialogContentText>
              </DialogContent>

              <DialogActions>
                <Button
                  disabled={claimFormAttached}
                  variant='contained'
                  size='small'
                  onClick={() => handleUpload('CLAIM_FORM', generatedClaimFile)}
                  color='primary'
                >
                  Attach PDF{' '}
                  {claimFormAttached && (
                    <CheckCircleIcon sx={{ fontSize: 15 }} />
                  )}
                </Button>
                <Button
                  variant='outlined'
                  size='small'
                  onClick={handleDownload}
                  color='primary'
                >
                  Download PDF
                </Button>
              </DialogActions>
            </Dialog>
            <Grid container spacing={3} sx={{ mt: 2 }}>
              <Grid item xs={12}>
                <Typography variant='h6' sx={{ mb: 2, color: 'text.primary' }}>
                  Document Generation
                </Typography>
              </Grid>

              {/* Packaging Slip */}
              <Grid item xs={12} md={3}>
                <DocumentGenerationCard
                  title='Packaging Slip'
                  buttonText='Generate Packaging Slip'
                  isAttached={packagingSlipAttached}
                  onGenerate={() => setPackagingSlipDialogOpen(true)}
                  files={claimFormData.pictures?.filter(file =>
                    file.name.includes('Slip')
                  )}
                  onRemoveFile={idx => {
                    setPreviewUrlSlip(null);
                    const slipFiles = claimFormData.pictures?.filter(file =>
                      file.name.includes('Slip')
                    );
                    const actualIndex = claimFormData.pictures?.findIndex(
                      file => file === slipFiles[idx]
                    );
                    if (actualIndex !== -1) handleRemoveFile(actualIndex);
                  }}
                  icon={<LocalShipping sx={{ fontSize: 24 }} />}
                  color='#2196f3'
                />
              </Grid>

              {/* Bill of Lading */}
              <Grid item xs={12} md={3}>
                <DocumentGenerationCard
                  title='Bill of Lading'
                  buttonText='Generate Bill of Lading'
                  isAttached={BOLAttached}
                  onGenerate={() => setBillOfLadingDialog(true)}
                  files={claimFormData.pictures?.filter(file =>
                    file.name.includes('BOL')
                  )}
                  onRemoveFile={idx => {
                    const bolFiles = claimFormData.pictures?.filter(file =>
                      file.name.includes('BOL')
                    );
                    setPreviewUrlBOL(null);
                    const actualIndex = claimFormData.pictures?.findIndex(
                      file => file === bolFiles[idx]
                    );
                    if (actualIndex !== -1) handleRemoveFile(actualIndex);
                  }}
                  icon={<Description sx={{ fontSize: 24 }} />}
                  color='#ff9800'
                />
              </Grid>
              {/* Proof of Delivery */}
              <Grid item xs={12} md={3}>
                <DocumentGenerationCard
                  title='Proof of Delivery'
                  buttonText='Generate Proof of Delivery'
                  isAttached={proofOfDeliveryAttached}
                  onGenerate={() => {
                    handleProofOfDeliveryRequest();
                    setProofOfDeliveryDialog(true);
                  }}
                  files={claimFormData.pictures?.filter(file =>
                    file.name.includes('Proof')
                  )}
                  onRemoveFile={idx => {
                    setPreviewProofOfDelivery([]);
                    setFiles([]);
                    setProofOfDeliveryAttached(false);
                    const slipFiles = claimFormData.pictures?.filter(file =>
                      file.name.includes('Proof')
                    );
                    const actualIndex = claimFormData.pictures?.findIndex(
                      file => file === slipFiles[idx]
                    );
                    if (actualIndex !== -1) handleRemoveFile(actualIndex);
                  }}
                  icon={<AirportShuttle sx={{ fontSize: 24 }} />}
                  color='#9baf51'
                />
              </Grid>
              {/* Claim Form */}
              <Grid item xs={12} md={3}>
                <DocumentGenerationCard
                  title='Claim Form'
                  buttonText='Generate Claim Form'
                  isAttached={claimFormAttached}
                  onGenerate={() => {
                    setClaimFormDialog(true);
                    generatePreview();
                  }}
                  files={claimFormData.pictures?.filter(file =>
                    file.name.includes('Claim')
                  )}
                  onRemoveFile={idx => {
                    const claimFiles = claimFormData.pictures?.filter(file =>
                      file.name.includes('Claim')
                    );
                    setPreviewUrl(null);
                    const actualIndex = claimFormData.pictures?.findIndex(
                      file => file === claimFiles[idx]
                    );
                    if (actualIndex !== -1) handleRemoveFile(actualIndex);
                  }}
                  icon={<Assignment sx={{ fontSize: 24 }} />}
                  color='#4caf50'
                />
              </Grid>

              {/* Progress Summary */}
              <Grid item xs={12}>
                <Card
                  sx={{
                    backgroundColor: '#f8f9fa',
                    border: '1px solid #e9ecef'
                  }}
                >
                  <CardContent sx={{ py: 2 }}>
                    <Typography variant='subtitle2' sx={{ mb: 2 }}>
                      Document Generation Progress
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                      <Chip
                        icon={<LocalShipping />}
                        label={`Packaging Slip ${
                          packagingSlipAttached ? '✓' : '○'
                        }`}
                        color={packagingSlipAttached ? 'primary' : 'default'}
                        variant={packagingSlipAttached ? 'filled' : 'outlined'}
                        size='small'
                      />
                      <Chip
                        icon={<Description />}
                        label={`Bill of Lading ${BOLAttached ? '✓' : '○'}`}
                        color={BOLAttached ? 'warning' : 'default'}
                        variant={BOLAttached ? 'filled' : 'outlined'}
                        size='small'
                      />
                      <Chip
                        icon={<AirportShuttle />}
                        label={`Proof of Delivery ${
                          proofOfDeliveryAttached ? '✓' : '○'
                        }`}
                        color={proofOfDeliveryAttached ? 'warning' : 'default'}
                        variant={
                          proofOfDeliveryAttached ? 'filled' : 'outlined'
                        }
                        size='small'
                      />
                      <Chip
                        icon={<Assignment />}
                        label={`Claim Form ${claimFormAttached ? '✓' : '○'}`}
                        color={claimFormAttached ? 'success' : 'default'}
                        variant={claimFormAttached ? 'filled' : 'outlined'}
                        size='small'
                      />
                    </Box>
                    <Typography
                      variant='caption'
                      color='text.secondary'
                      sx={{ mt: 1, display: 'block' }}
                    >
                      Complete all document generation steps to proceed with
                      your claim.
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </>
        )}
        {activeStep === 2 && (
          <>
            {/* Shipment Info Preview*/}
            <Typography
              variant='subtitle1'
              sx={{ mt: 1, mb: 1, fontWeight: 500 }}
            >
              Shipment Information
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} md={3}>
                <Typography variant='caption' sx={{ color: 'text.secondary' }}>
                  Carrier’s Freight Bill No.
                </Typography>
                <Typography variant='body1'>
                  {formData.carriersFreightBillNo || '-'}
                </Typography>
              </Grid>
              <Grid item xs={12} md={3}>
                <Typography variant='caption' sx={{ color: 'text.secondary' }}>
                  Shipper’s Name
                </Typography>
                <Typography variant='body1'>
                  {formData.shippersName || '-'}
                </Typography>
              </Grid>
              <Grid item xs={12} md={3}>
                <Typography variant='caption' sx={{ color: 'text.secondary' }}>
                  Consignee’s Name
                </Typography>
                <Typography variant='body1'>
                  {formData.consigneesName || '-'}
                </Typography>
              </Grid>
              <Grid item xs={12} md={3}>
                <Typography variant='caption' sx={{ color: 'text.secondary' }}>
                  Date of Delivery
                </Typography>
                <Typography variant='body1'>
                  {formData.dateOfDelivery || '-'}
                </Typography>
              </Grid>
            </Grid>
            <Divider sx={{ my: 1 }} />
            {/* Claimant Info Preview */}
            <Typography
              variant='subtitle1'
              sx={{ mt: 2, mb: 1, fontWeight: 500 }}
            >
              Claimant Information
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} md={3}>
                <Typography variant='caption' sx={{ color: 'text.secondary' }}>
                  Company Name
                </Typography>
                <Typography variant='body1'>
                  {formData.claimantCompanyName || '-'}
                </Typography>
              </Grid>
              <Grid item xs={12} md={3}>
                <Typography variant='caption' sx={{ color: 'text.secondary' }}>
                  Contact Name
                </Typography>
                <Typography variant='body1'>
                  {formData.claimantContactName || '-'}
                </Typography>
              </Grid>
              <Grid item xs={12} md={3}>
                <Typography variant='caption' sx={{ color: 'text.secondary' }}>
                  Email
                </Typography>
                <Typography variant='body1'>
                  {formData.claimantEmail || '-'}
                </Typography>
              </Grid>
              <Grid item xs={12} md={3}>
                <Typography variant='caption' sx={{ color: 'text.secondary' }}>
                  Phone
                </Typography>
                <Typography variant='body1'>
                  {formData.claimantPhone || '-'}
                </Typography>
              </Grid>
              <Grid item xs={12} md={3}>
                <Typography variant='caption' sx={{ color: 'text.secondary' }}>
                  Address
                </Typography>
                <Typography variant='body1'>
                  {formData.claimantAddress || '-'}
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <Typography variant='caption' sx={{ color: 'text.secondary' }}>
                  City, State, Zip
                </Typography>
                <Typography variant='body1'>
                  {formData.claimantCityStateZip || '-'}
                </Typography>
              </Grid>
            </Grid>
            <Divider sx={{ my: 1 }} />

            {/* Claim Type Preview */}
            <Typography
              variant='subtitle1'
              sx={{ mt: 1, mb: 1, fontWeight: 500 }}
            >
              Claim Type
            </Typography>
            <Typography variant='body1'>{formData.claimType || '-'}</Typography>
            <Divider sx={{ my: 1 }} />

            {/* Item Details Preview*/}
            <Typography
              variant='subtitle1'
              sx={{ mt: 2, mb: 1, fontWeight: 500 }}
            >
              Item Details
            </Typography>
            {items.length > 0 ? (
              items.map((item, index) => (
                <Grid
                  container
                  spacing={1}
                  key={index}
                  sx={{
                    mb: 2,
                    mt: 1,
                    p: -2,
                    border: '1px solid #eee',
                    borderRadius: 2,
                    backgroundColor: '#fafafa'
                  }}
                >
                  <Grid item xs={6} md={2}>
                    <Typography
                      variant='caption'
                      sx={{ color: 'text.secondary' }}
                    >
                      Quantity
                    </Typography>
                    <Typography variant='body1'>{item.units || '-'}</Typography>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Typography
                      variant='caption'
                      sx={{ color: 'text.secondary' }}
                    >
                      Description
                    </Typography>
                    <Typography variant='body1'>
                      {item.itemDescription || '-'}
                    </Typography>
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <Typography
                      variant='caption'
                      sx={{ color: 'text.secondary' }}
                    >
                      Unit Price
                    </Typography>
                    <Typography variant='body1'>
                      {item.itemUnitPrice || '-'}
                    </Typography>
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <Typography
                      variant='caption'
                      sx={{ color: 'text.secondary' }}
                    >
                      Total Amount
                    </Typography>
                    <Typography variant='body1'>
                      {item.itemTotalAmount || '-'}
                    </Typography>
                  </Grid>
                </Grid>
              ))
            ) : (
              <Typography variant='body2' sx={{ color: 'text.secondary' }}>
                No items added
              </Typography>
            )}

            {/* Claim Amount Preview*/}
            <Typography
              variant='subtitle1'
              sx={{ mt: 1, mb: 1, fontWeight: 500 }}
            >
              Claim Details
            </Typography>
            <Typography variant='caption' sx={{ color: 'text.secondary' }}>
              Claim Amount
            </Typography>
            <Typography variant='body1'>
              {formData.claimAmount || '-'}
            </Typography>
            <Divider sx={{ my: 1 }} />
            <Box sx={{ mt: 3 }}>
              {/* Claim Images/Attachments Section */}
              <Card sx={{ mb: 4, border: '1px solid #e0e0e0' }}>
                <CardHeader
                  avatar={<ImageIcon sx={{ color: '#4caf50' }} />}
                  title='Claim Images & Attachments'
                  subheader={`${
                    claimFormData.pictures?.filter(
                      file =>
                        !file.name.includes('Slip') &&
                        !file.name.includes('BOL') &&
                        !file.name.includes('Claim') &&
                        !file.name.includes('Proof')
                    ).length || 0
                  } files uploaded`}
                />
                <CardContent>
                  {claimFormData.pictures?.filter(
                    file =>
                      !file.name.includes('Slip') &&
                      !file.name.includes('BOL') &&
                      !file.name.includes('Claim') &&
                      !file.name.includes('Proof')
                  ).length > 0 ? (
                    <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                      {claimFormData.pictures?.map(
                        (file, idx) =>
                          !file.name.includes('Slip') &&
                          !file.name.includes('BOL') &&
                          !file.name.includes('Claim') &&
                          !file.name.includes('Proof') && (
                            <Box
                              key={idx}
                              sx={{
                                position: 'relative',
                                display: 'inline-block',
                                minWidth: 150,
                                maxWidth: 150
                              }}
                            >
                              <Box
                                sx={{
                                  width: 150,
                                  height: 150,
                                  display: 'flex',
                                  flexDirection: 'column',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  border: '1px solid #e0e0e0',
                                  borderRadius: 2,
                                  backgroundColor:
                                    getFileTypeInfo(file).bgColor,
                                  overflow: 'hidden',
                                  position: 'relative'
                                }}
                              >
                                {file.type.startsWith('image/') ? (
                                  <img
                                    src={URL.createObjectURL(file)}
                                    alt='attachment-preview'
                                    style={{
                                      width: '100%',
                                      height: '100%',
                                      objectFit: 'cover',
                                      borderRadius: 8
                                    }}
                                  />
                                ) : (
                                  <>
                                    <Box
                                      sx={{
                                        color: getFileTypeInfo(file).color,
                                        mb: 1
                                      }}
                                    >
                                      {getFileTypeInfo(file).icon}
                                    </Box>
                                    <Chip
                                      label={getFileTypeInfo(file).label}
                                      size='small'
                                      sx={{
                                        mb: 1,
                                        backgroundColor:
                                          getFileTypeInfo(file).color,
                                        color: 'white',
                                        fontSize: '10px'
                                      }}
                                    />
                                  </>
                                )}
                              </Box>

                              {/* File info overlay */}
                              <Box
                                sx={{
                                  position: 'absolute',
                                  bottom: 0,
                                  left: 0,
                                  right: 0,
                                  backgroundColor: 'rgba(0,0,0,0.8)',
                                  color: 'white',
                                  p: 0.5,
                                  borderRadius: '0 0 8px 8px'
                                }}
                              >
                                <Typography
                                  variant='caption'
                                  sx={{
                                    fontSize: '10px',
                                    display: 'block',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                  }}
                                >
                                  {file.name}
                                </Typography>
                                <Typography
                                  variant='caption'
                                  sx={{ fontSize: '9px', opacity: 0.8 }}
                                >
                                  {formatFileSize(file.size)}
                                </Typography>
                              </Box>
                            </Box>
                          )
                      )}
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        py: 4,
                        textAlign: 'center',
                        backgroundColor: '#f8f9fa',
                        borderRadius: 2,
                        border: '2px dashed #dee2e6'
                      }}
                    >
                      <ImageIcon
                        sx={{ fontSize: 48, color: '#6c757d', mb: 2 }}
                      />
                      <Typography color='text.secondary'>
                        No images or attachments uploaded yet
                      </Typography>
                    </Box>
                  )}
                </CardContent>
              </Card>

              {/* Document Previews Section */}
              <Typography
                variant='h5'
                sx={{ mb: 3, fontWeight: 600, color: 'text.primary' }}
              >
                Document Previews
              </Typography>

              {/* Packaging Slip Preview */}
              <PDFPreviewCard
                title='Packaging Slip'
                previewUrl={previewUrlSlip}
                icon={<LocalShipping sx={{ fontSize: 24 }} />}
                color='#2196f3'
                description='Generated packaging slip document for your claim'
              />

              {/* Bill of Lading Preview */}
              <PDFPreviewCard
                title='Bill of Lading'
                previewUrl={previewUrlBOL}
                icon={<Description sx={{ fontSize: 24 }} />}
                color='#ff9800'
                description='Generated bill of lading document for your claim'
              />
              <PDFPreviewCard
                title='Proof of Delivery'
                previewUrl={previewProofOfDelivery}
                icon={<Description sx={{ fontSize: 24 }} />}
                color='#ff9800'
                description='Generated proof of delivery document for your claim'
              />

              {/* Claim Form Preview */}
              <PDFPreviewCard
                title='Claim Form'
                previewUrl={previewUrl}
                icon={<Assignment sx={{ fontSize: 24 }} />}
                color='#4caf50'
                description={
                  previewUrl
                    ? 'SAIA Claim Form ready for submission'
                    : "Click 'Preview Claim Form' to generate preview"
                }
              />

              {/* Summary Card */}
              <Card
                sx={{
                  mt: 4,
                  backgroundColor: '#f8f9fa',
                  border: '1px solid #e9ecef'
                }}
              >
                <CardContent>
                  <Typography
                    variant='h6'
                    sx={{
                      mb: 2,
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1
                    }}
                  >
                    <Visibility sx={{ color: '#6c757d' }} />
                    Preview Summary
                  </Typography>
                  <Box
                    sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 2 }}
                  >
                    <Chip
                      icon={<ImageIcon />}
                      label={`${
                        claimFormData.pictures?.filter(
                          file =>
                            !file.name.includes('Slip') &&
                            !file.name.includes('BOL') &&
                            !file.name.includes('Claim') &&
                            !file.name.includes('Proof')
                        ).length || 0
                      } Attachments`}
                      variant='outlined'
                      size='small'
                    />
                    <Chip
                      icon={<LocalShipping />}
                      label={`Packaging Slip ${previewUrlSlip ? '✓' : '○'}`}
                      color={previewUrlSlip ? 'primary' : 'default'}
                      variant={previewUrlSlip ? 'filled' : 'outlined'}
                      size='small'
                    />
                    <Chip
                      icon={<Description />}
                      label={`Bill of Lading ${previewUrlBOL ? '✓' : '○'}`}
                      color={previewUrlBOL ? 'warning' : 'default'}
                      variant={previewUrlBOL ? 'filled' : 'outlined'}
                      size='small'
                    />
                    <Chip
                      icon={<AirportShuttle />}
                      label={`Proof of Delivery ${
                        proofOfDeliveryAttached ? '✓' : '○'
                      }`}
                      color={proofOfDeliveryAttached ? 'warning' : 'default'}
                      variant={proofOfDeliveryAttached ? 'filled' : 'outlined'}
                      size='small'
                    />
                    <Chip
                      icon={<Assignment />}
                      label={`Claim Form ${previewUrl ? '✓' : '○'}`}
                      color={previewUrl ? 'success' : 'default'}
                      variant={previewUrl ? 'filled' : 'outlined'}
                      size='small'
                    />
                  </Box>
                  <Typography variant='body2' color='text.secondary'>
                    Review all documents and attachments before final
                    submission.
                  </Typography>
                </CardContent>
              </Card>
            </Box>
          </>
        )}
      </DialogContent>

      <DialogActions>
        <Stack
          direction='row'
          spacing={1}
          sx={{
            width: '100%',
            justifyContent: 'end'
          }}
        >
          {activeStep !== 0 && (
            <Button size='small' variant='outlined' onClick={handleBack}>
              Back
            </Button>
          )}
          {activeStep < steps.length - 1 ? (
            <Button
              size='small'
              variant='contained'
              onClick={handleNext}
              disabled={isGenerating}
            >
              Next
            </Button>
          ) : (
            <Stack direction='row' spacing={1}>
              <Button
                size='small'
                variant='contained'
                color='success'
                onClick={handleSubmit}
              >
                Submit Claim
              </Button>
            </Stack>
          )}
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default SaiaClaimFormStepper;
